import React from 'react';
import { translate } from 'components/Translation';
import { BodyM } from 'components/Typography/Typography';
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog';

interface IDuplicatedNumbersWarningDialog {
	isOpen: boolean;
	hideDialog: () => void;
}

const DuplicatedNumbersWarningDialog = ({ isOpen, hideDialog }: IDuplicatedNumbersWarningDialog) => {
	return (
		<ConfirmationDialog
			header={translate('prepaid.loyalty.add.numbers.duplicates.found')}
			isOpen={isOpen}
			hideDialog={hideDialog}
			dialogBody={
				<>
					<BodyM disableMargin>{translate('prepaid.loyalty.add.numbers.duplicates.found.explainer')}</BodyM>
				</>
			}
			buttons={[
				{
					text: translate('yes'),
					color: 'primary-light',
					onClick: hideDialog,
				},
			]}
		/>
	);
};

export default DuplicatedNumbersWarningDialog;
